import type React from 'react';
import { ButtonWithPopupWrapperProps } from './types';
import ButtonWithPopupWrapperView from './ButtonWithPopupWrapper.View';
import { useState } from 'react';

const ButtonWithPopupWrapper: React.FC<ButtonWithPopupWrapperProps> = (props) => {
  const [open, setOpen] = useState(false);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  return <ButtonWithPopupWrapperView open={open} onOpen={onOpen} onClose={onClose} {...props} />;
};

export default ButtonWithPopupWrapper;
